// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__2XuCu"};